const product = {
  namespaced: true,
  state: {
    item: null,
  },
  mutations: {
    setProduct(state, payload) {
      if (state.item !== payload) {
        state.item = payload;
      } else {
        state.item = null;
      }
    },
    unsetProduct(state) {
      state.item = null;
    },
  },
  actions: {},
  getters: {},
};

export default product;
